import { cn } from '~/shared/lib/cn';
import { LinkTypes } from '~/shared/model/link-types.ts';
import { NavLinks } from '~/shared/ui/nav-links';

export function Navigation({ className }: { className?: string } = {}) {
  return (
    <nav className={cn('', className)}>
      <NavLinks linkType={LinkTypes.BASE} onLinkClick={() => false} />
    </nav>
  );
}
